export var LI_FI_WALLET_NAMES;
(function (LI_FI_WALLET_NAMES) {
    LI_FI_WALLET_NAMES["DEFAULT"] = "Default Wallet";
    LI_FI_WALLET_NAMES["WALLET_CONNECT"] = "WalletConnect";
    LI_FI_WALLET_NAMES["EXODUS"] = "Exodus";
    LI_FI_WALLET_NAMES["METAMASK"] = "MetaMask";
})(LI_FI_WALLET_NAMES || (LI_FI_WALLET_NAMES = {}));
